import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { ContenedorComponent } from './contenedor/contenedor.component';
@NgModule({
  imports: [
    RouterModule,
    SharedModule
  ],
  declarations: [
    ContenedorComponent
  ],
})
export class ComponentsModule { }
